import React from 'react';
import Line from '@splunk/dashboard-visualizations/Line';

export default () => (
    <Line
        options={{}}
        encoding={{
            x: 'primary._time',
            y: 'primary.count',
            annotationX: 'annotation._time',
            annotationLabel: 'annotation.annotation_label',
            annotationColor: 'annotation.annotation_color',
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: '_time', groupby_rank: '0' }, { name: 'count' }, { name: '_span' }],
                    columns: [
                        [
                            '2018-05-02T18:10:46.000-07:00',
                            '2018-05-02T18:11:47.000-07:00',
                            '2018-05-02T18:12:48.000-07:00',
                            '2018-05-02T18:13:49.000-07:00',
                            '2018-05-02T18:15:50.000-07:00',
                        ],
                        ['2', '10', '13', '60', '43'],
                        ['1', '1', '1', '1', '1'],
                    ],
                },
                meta: { totalCount: 20 },
            },
            annotation: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [
                        { name: '_time', groupby_rank: '0' },
                        { name: 'annotation_label' },
                        { name: 'annotation_color' },
                    ],
                    columns: [
                        [
                            '2018-05-02T18:11:50.000-07:00',
                            '2018-05-02T18:13:25.000-07:00',
                            '2018-05-02T18:14:30.000-07:00',
                        ],
                        ['houston, we have a problem', 'just close the jira', 'looking good now'],
                        ['#f44271', '#f4a941', '#41f49a'],
                    ],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
